angular.module("app").directive("indeterminate", function () {
  return {
    // Restrict the directive so it can only be used as an attribute
    restrict: "A",

    link: function (scope, elem, attr) {
      // Whenever the bound value of the attribute changes we update
      // the internal 'indeterminate' flag on the attached dom element
      var watcher = scope.$watch(attr.indeterminate, function (value) {
        (elem[0] as any).indeterminate = value;
      });

      // Remove the watcher when the directive is destroyed
      scope.$on("$destroy", function () {
        watcher();
      });
    },
  };
});
